export const IMPORT_TERMINAL_STATUSES = new Set(['Completed', 'Completed with error']);
export const IMPORT_POLL_INTERVAL_MS = 3_000;

export interface ImportHistoryStatusItem {
  id?: number;
  status?: string | null;
}

export function getImportPollingInterval(items: ImportHistoryStatusItem[] | undefined, trackedImportId?: number | null): number | false {
  if (!Array.isArray(items)) {
    return trackedImportId ? IMPORT_POLL_INTERVAL_MS : false;
  }

  const hasActiveImport = items.some((item) => !IMPORT_TERMINAL_STATUSES.has(item.status ?? ''));
  if (!trackedImportId) {
    return hasActiveImport ? IMPORT_POLL_INTERVAL_MS : false;
  }

  const trackedImport = items.find((item) => item.id === trackedImportId);
  if (!trackedImport) {
    return IMPORT_POLL_INTERVAL_MS;
  }

  if (!IMPORT_TERMINAL_STATUSES.has(trackedImport.status ?? '')) {
    return IMPORT_POLL_INTERVAL_MS;
  }

  return hasActiveImport ? IMPORT_POLL_INTERVAL_MS : false;
}

export function checkIsImportActive(items: ImportHistoryStatusItem[] | undefined, trackedImportId?: number | null): boolean {
  return getImportPollingInterval(items, trackedImportId) !== false;
}
